import { useDaily } from '@daily-co/daily-react';

export const useCall = () => {
  // TODO: create a wrapper for returning callObject
  const callObject = useDaily();

  const joinCall = async ({ url, token }: { url: string | null; token: string | null }) => {
    if (!(url && token)) {
      console.error('Error: Missing room_url and token.');
      return;
    }

    await callObject?.preAuth({ url, token });
    await callObject?.startCamera({ startVideoOff: true, startAudioOff: true });
    await callObject?.join({ url, token });
  };

  return { joinCall };
};
